import React from 'react'
import "./Enquire_from_modal.css"
import { Modal } from 'react-bootstrap'
import Form_component from '../../../contact_us/contact_form/Form_component'

function Enquire_from_modal(props) {
    return (
        <>
            <Modal
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className="Enquire_from_modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter" >
                        Grow with Us
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form_component closeModal={props?.onHide}/>
                </Modal.Body>

            </Modal>
        </>
    )
}

export default Enquire_from_modal